import { useQuery } from "hooks/useQuery";
import { getPerformanceDataV2 } from "features/Dashboard/service";

export const usePerformanceData = (brokerAccountId) => {
  const { isLoading, data } = useQuery({
    key: "performanceData",
    queryKey: ["performanceData", brokerAccountId],
    queryFn: async () => {
      const params = {
        broker_account_id: brokerAccountId,
      };
      const response = await getPerformanceDataV2(params);
      return response;
    },
    enabled: Boolean(brokerAccountId),
  });

  return {
    isLoading,
    performanceData: data,
    chartsData: data?.charts_data || {},
  };
};
